import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const PowerPlant: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m600 90h-180v-30h150c16.57 0 30 13.43 30 30z' />
    <path d='m660 150h-180v-30h150c16.57 0 30 13.43 30 30z' />
    <path d='m325 660h-126.63c-12.06 0-23.12-6.08-29.57-16.27-6.45-10.18-7.23-22.76-2.08-33.65 16.17-34.23 43.29-105.75 43.29-200.08s-13.35-156.79-21.31-185.74c-2.92-10.61-.76-21.72 5.91-30.48 6.68-8.76 16.83-13.78 27.84-13.78h132.56v30h-132.56c-2.16 0-3.42 1.23-3.98 1.97-.56.73-1.41 2.27-.84 4.34 8.36 30.41 22.38 96.01 22.38 193.69s-28.92 176.38-46.16 212.89c-1.02 2.15-.25 3.92.3 4.79s1.83 2.33 4.23 2.33h126.63v30z' />
    <path d='m594.97 660h-126.63v-30h126.63c2.4 0 3.68-1.46 4.23-2.33.55-.86 1.31-2.63.3-4.79-17.24-36.5-46.16-112.7-46.16-212.89s14.02-163.28 22.38-193.69c.57-2.07-.28-3.61-.84-4.34-.56-.74-1.82-1.97-3.98-1.97h-132.56v-30h132.56c11.02 0 21.17 5.02 27.84 13.78 6.67 8.75 8.83 19.86 5.91 30.48-7.96 28.95-21.31 91.58-21.31 185.74s27.12 165.84 43.29 200.08c5.15 10.9 4.37 23.48-2.08 33.65-6.46 10.19-17.51 16.27-29.57 16.27z' />
    <path d='m300 180h185v30h-185z' />
    <path d='m300 630h185v30h-185z' />
  </IconBase>
));

PowerPlant.displayName = 'PowerPlant';

export default PowerPlant;
